import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocation = createSelector(
  [(store: RootState) => store.locationShow.location],
  (data) => data
);
